import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    service: null,
    services: [],
    serviceForm: null,
    serviceErrors: null,
    serviceFilters: null,
    servicePriceIntervalsAdded: [],
    servicePriceIntervalsRemoved: [],
    servicePriceIntervalsAddedMarkedForRemoval: [],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
